import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { getBouLinkStyle } from '../../../generic/content/texts/bou-link';
import { getTextStyle } from '../../../generic/content/texts/bou-text/text-style';
import { BouColor } from '../../../generic/global/bou-colors';
import {
  BouSpacingLevel,
  fluidHorizontalPadding,
  fluidSpacing,
  fluidVerticalPadding,
} from '../../../generic/layout/bou-spacing';
import { mobileOrNarrower } from '../../../generic/layout/breakpoint-utils';

const Links = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  a {
    display: block;
    ${fluidVerticalPadding(BouSpacingLevel.MICRO)}
    ${fluidSpacing('padding-left', BouSpacingLevel.TINY)}
    ${getBouLinkStyle(false, undefined, 'lighter')}
  }
  a:hover {
    color: ${BouColor.TOOL_HOVER_DARK_GRAY};
  }
  ${mobileOrNarrower(css`
    flex-wrap: wrap;
  `)}
`;

const Root = styled.div`
  ${getTextStyle({ size: 'xxxxs' })}
  ${fluidHorizontalPadding(BouSpacingLevel.TINY)}
`;

export interface Link {
  label: string;
  url: string;
}

interface Props {
  links: Link[];
}

export const Toolbar = ({ links }: Props) => {
  return (
    <Root>
      <Links>
        {links.map(({ label, url }) => (
          <NavLink key={url} to={url}>
            {label}
          </NavLink>
        ))}
      </Links>
    </Root>
  );
};
